import PropTypes from 'prop-types'
import React from 'react'

import LandingPageContentCollapsible from '../../landingPage/components/LandingPageContentCollapsible'

const OverviewDescription = ({ children }) => {
  return (
    <LandingPageContentCollapsible>
      <div dangerouslySetInnerHTML={{ __html: children }} />
    </LandingPageContentCollapsible>
  )
}

OverviewDescription.propTypes = {
  children: PropTypes.string.isRequired
}

export default OverviewDescription
